
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/josefin-sans'; // Defaults to 400 weight

import './App.css'
import "./Css/Responsive.css"
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import Home from './Page/Home';
import MemberShip from './Page/MemberShip';
import ContactUs from './Page/ContactUs';
import AboutUs from './Page/AboutUs';
import Packges from './Page/Packges';
import ScrollTop from './Component/ScrollTop';
import Testimonial from './Page/Testimonial';
import MembershipPage from './Page/MembershipPage';
import Blog from './Page/Blog';

function App() {
  return (
    <React.Fragment>
     
  
       <BrowserRouter>
       <ScrollTop />
       <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Navigate to="/" replace/>} />
      <Route path="/membership-form" element={<MemberShip />} />
      <Route path="/membership" element={<MembershipPage />} />
      <Route path="/testimonial" element={<Testimonial />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/packgaes" element={<Packges />} />
    </Routes>
    </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
